/***************************************************/
/*                  Attention!                     */
/*      Some of the input types have different     */
/*      regexes for typing/keying in and fot       */
/*      validation                                 */
/***************************************************/

export const addressRe = /^[a-zA-Z0-9][a-zA-Z0-9-., ]*$/;
export const birthdayTypingRe = /^\d(?:\d|$)(?:\d|$)(?:\d|$)(?:\/|$)(?:\d|$)(?:\d|$)(?:\/|$)(?:\d|$)(?:\d|$)$/;
export const birthdayValidationRe = /^[1-2]\d\d\d\/[0-1]\d\/[0-3]\d$/;
// export const emailTypingRe = /^([a-z0-9-_.]*)(@|$)([a-z0-9]+|$)(\.|$)([a-z.]+|$)$/;
// export const emailTypingRe = /^(?:[a-zA-Z0-9_\-&!$%^*=+`~?]|(:?[a-zA-Z0-9_\-&!$%^*=+`~?])\.)+(?:@|$)(?:(?:[a-zA-Z0-9]|(:?[a-zA-Z0-9])-)+|$)(?:\.|$)(?:(?:[a-zA-Z0-9]|(:?[a-zA-Z0-9])-)+|$)(?:\.?|$)(?:(?:[a-zA-Z0-9]|(:?[a-zA-Z0-9])-)+|$)$/;
export const emailValidationRe = /^(?:[a-zA-Z0-9_\-&!$%^*=+`~?]|(:?[a-zA-Z0-9_\-&!$%^*=+`~?])\.(?=[a-zA-Z0-9_\-&!$%^*=+`~?]))+@(?:[a-zA-Z0-9]|(:?[a-zA-Z0-9])-(?=[a-zA-Z0-9]))+\.(?:[a-zA-Z0-9]|(:?[a-zA-Z0-9])-(?=[a-zA-Z0-9]))+\.?(?:[a-zA-Z0-9]|(:?[a-zA-Z0-9])-(?=[a-zA-Z0-9]))+$/;
export const nameTypingRe = /^[[a-zA-Z](?:[a-z]|(:?[ \-])[A-Z]|(:?[a-zA-Z])[ \-_])*$/;
export const nameValidationRe = /^[a-zA-Z](?:[a-z]|(:?[ \-])[A-Z]|(:?[a-zA-Z])[ \-_](?=[a-zA-Z]))*$/;
export const numberRe = /^[1-9-]?[0-9]*$/;
export const phoneTypingRe = /^\+?[0-9]*$/;
export const phoneValidationRe = /^\+?[0-9]+$/;
export const recIdRe = /^[1-9][0-9]?$/;
export const urlRe = /^https?:\/\/.*?\.(png|jpg)$/;//
export const elliqIdRe = /^[a-z0-9]+(?:-[a-z0-9]+){2}$/;
export const regPmName = /^[a-z0-9-_\.]{3,}$/;